import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledStats = styled.div`
  display: flex;
  align-items: center;
  ${({ marginRight }) =>
    `margin-right: ${marginRight ? marginRight : '3rem'};`};
  font-size: 1.5rem;
  color: ${getColor('shuttleGray')};
  & > svg {
    margin-right: 0.8rem;
  }
`;
